/* tslint:disable */

import { Action } from '@ngrx/store';
import { IListViewData } from 'src/ng2/shared/typings/interfaces/list-view.interface';
export const UPDATE_CSV_DATA = '[Portal] Update CSV Data';

export class UpdateCsvData implements Action {
  readonly type = UPDATE_CSV_DATA;
  constructor(public payload: any) {}
}

// action types
export type CsvDataAction = UpdateCsvData;
